const MAANDNAMEN = [
  'jan',
  'feb',
  'mrt',
  'apr',
  'mei',
  'jun',
  'jul',
  'aug',
  'sep',
  'okt',
  'nov',
  'dec',
];

/**
 * Het aslabel van een tijdvak: bij een maand-periode zijn de tijdvakken dagen
 * ("2026-08-05" → "5"), bij een jaar maanden ("2026-03" → "mrt").
 *
 * Gedeeld tussen de twee grafieken, want die staan boven elkaar en horen
 * dezelfde as te tonen.
 */
export const asTijdvakLabel = (tijdvak: string): string =>
  tijdvak.length > 7
    ? String(Number(tijdvak.slice(8)))
    : (MAANDNAMEN[Number(tijdvak.slice(5, 7)) - 1] ?? tijdvak);
